import { uuidv4 } from '@embed/helpers';
/**
 * Format`video.video_subtitles` array to be used in the player
 * @param subtitles
 * @returns
 */
export const formatVideoSubtitles = (subtitles) => {
    return subtitles
        ? subtitles.map((s) => ({
            src: s.url || s.key,
            srclang: s.language || s.locale || 'en-US', // temporary measure until CS-4517 is done
            is_cc: s.is_cc || false,
            id: s.id,
        }))
        : [];
};
/**
 * Format `live_stream_subtitles` array to be used in the player
 * @param subtitles
 * @returns
 */
export const formatLiveStreamSubtitles = (subtitles) => {
    if (!subtitles || subtitles.length === 0) {
        return [];
    }
    /**
     * Temporary fix until CS-4517 is done to seamlessly support both shapes
     * when the change over happens, will remove
     * TODO: CS-4593
     */
    if (subtitles[0].language !==
        undefined) {
        return formatVideoSubtitles(subtitles);
    }
    return subtitles
        ? subtitles.map((s) => ({
            src: s.key,
            srclang: s.locale,
            is_cc: s.is_cc || false,
            id: s.id || uuidv4(),
        }))
        : [];
};
